export const adaptDeposito = (depositoData) => {
    return {
        id: depositoData?.idDeposito,
        displayName: depositoData?.descripcion,
        name: depositoData?.descripcion
    }
}

export const adaptDepositoArray = (
    depositos
) => {
    return structuredClone(depositos?.allDeposito)
        ?.map(deposito => adaptDeposito(deposito));
}